export const GetStoreIds = ( stores ) => {
    return stores.map(item => item.id);
};
  